import * as React from 'react';
import { useState } from 'react';
import Popover from '@mui/material/Popover';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import Options from '../../Media/Svg/Options';
import { OptionsModalStyles } from './styles';
import CloseIconModals from '../../Media/Svg/CloseIconModals';
import EditIcon from '../../Media/Svg/EditIcon';
import DeleteIcon from '../../Media/Svg/DeleteIcon';
import './OptionsModal.css';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { deleteAffiliate, editAffiliate, fetchAffiliates } from '../../../redux';
import { fetchUser } from '../../../redux/actions/user/userActions';
import { toggleAdminRole } from '../../../redux/actions/adminAffiliates/adminAffliatesaActions';
import ComboBox2 from '../../Filters/AffiliateSalesEditFilter/AffiliateSalesEditFilter';
import TextField from '@mui/material/TextField';


interface OptionsModalType {
  row: {
    AppUserID: number;
    AffiliateName: Array<string>;
    UserName: string;
    Email: string;
    Detail: any;
    IsAdmin: number;
  };
  setCurrentPage: (a: number) => void;
}

export default function OptionsModal({ row }: OptionsModalType): any {
  const classes = OptionsModalStyles();
  const dispatch = useAppDispatch();
  const currentUserEmail = useAppSelector((store: any) => store.user.user?.Email);
  const allSystemAffiliates = useAppSelector((store: any) => store.support.affiliateArray);
  // Map affiliates to have label and value
  const allAffiliates = (allSystemAffiliates || []).map((affiliate: any) => ({
    AffiliateName: affiliate.AffiliateName,
    label: affiliate.AffiliateName,
    value: affiliate.AffiliateName,
  }));


  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  const [username, setUsername] = useState(row.UserName);
  const [email, setEmail] = useState(row.Email);

  // Sync local state when the row prop changes (e.g. after a re-fetch updates the store)
  React.useEffect(() => {
    setUsername(row.UserName);
    setEmail(row.Email);
  }, [row.UserName, row.Email]);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick: any = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose: any = () => {
    setAnchorEl(null);
  };

  const handleOpenModal: any = () => {
    if (!allSystemAffiliates || allSystemAffiliates.length === 0) {
      dispatch(fetchAffiliates());
    }
    setOpenModal(true);
  };
  const handleCloseModal: any = () => {
    setOpenModal(false);
  };


  const handleOpenModalDelete: any = () => setOpenModalDelete(true);
  const handleCloseModalResetDelete: any = () => setOpenModalDelete(false);

  const handleToggleAdmin = (): void => {
    dispatch(toggleAdminRole(row.AppUserID, row.Email, row.IsAdmin));
    handleClose();
  };

  ////////////////////////////DELETE USER////////////////////
  const deleteRow = async (): Promise<void> => {
    const deleteId = row.AppUserID.toString();
    dispatch(deleteAffiliate(deleteId));
    handleCloseModalResetDelete();
    handleCloseModal();
    handleClose();
  };

  ////////////////////EDIT USER/////////////////////////////////////
  const trimmedRowAffiliateNames = row.AffiliateName
  ? row.AffiliateName.map((name: string) => name.trim()) : [];

  const [selectedOptions, setSelectedOptions] = useState<any>(
    allAffiliates.filter((affiliate: any) =>
      trimmedRowAffiliateNames.includes(affiliate.AffiliateName.trim())));

  
  const supportFetched = useAppSelector((store: any) => store.support.fetched);

  React.useEffect(() => {
    const trimmed = row.AffiliateName
      ? row.AffiliateName.map((name: string) => name.trim()) : [];
    setSelectedOptions(allAffiliates.filter((affiliate: any) =>
      trimmed.includes(affiliate.AffiliateName.trim())));
  }, [row, supportFetched]);
  
  const editData = (): void => {
    const EdittedAffiliates = selectedOptions.map((object: any) => {
      return object.AffiliateName;
    });
    const headervalue = {
      UserID: row.AppUserID,
      UserName: username,
      Email: email,
      AffiliateName: EdittedAffiliates,
    };
    dispatch(editAffiliate(headervalue));
    // If editing the current user, refresh their profile
    if (email === currentUserEmail) {
      setTimeout(() => dispatch(fetchUser()), 1000);
    }
    handleCloseModal();
    handleClose();
  };
  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        className={classes.optionsButton}
        onClick={handleClick}
      >
        <Options />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        className={`modalPopover muiPopupBox ${classes.popoverContent}`}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div>
          <Button onClick={handleOpenModal} className={classes.EditButtonPopover}>
            <EditIcon /> Edit User Details
          </Button>
          <Modal
            keepMounted
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
          >
            <Box className={classes.modal}>
              <CloseIconModals setSnackClose={handleCloseModal} />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
                className={classes.modalTitle}
              >
                Edit User Details
              </Typography>
              <TextField
                label="Username"
                variant="outlined"
                fullWidth
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className={classes.textFields}
                sx={{ marginTop: '8px' }}
              />
               <ComboBox2
                label='Affiliate'
                placeholder='Placeholder for textbox'
                selectAllLabel='Select all'
                setAffiliateDropDown={setSelectedOptions}
                component='OptionsModal'
                optionsData={allAffiliates}
                selectedOptions={selectedOptions}
              />
              <TextField
                label="Email Address"
                variant="outlined"
                fullWidth
                value={email}
                className={classes.textFields}
                sx={{ marginTop: '8px' }}
                InputProps={{ readOnly: true }}
                disabled
              />
              <Typography variant="body2" sx={{ mt: 0.5, color: '#666', fontSize: '0.8rem' }}>
                Email cannot be changed because it must match your Single Sign-On account.
                To use a different email, please{' '}
                <a
                  href={`${import.meta.env.VITE_SSO_URL}/signup?clientId=${import.meta.env.VITE_COGNITO_CLIENT_ID}&callbackUrl=${import.meta.env.VITE_SSO_CALLBACK_URL}`}
                  style={{ color: '#007db3', textDecoration: 'underline' }}
                >
                  create a new account
                </a>.
              </Typography>
              <>
              &nbsp;
              <Button
                type="submit"
                variant="contained"
                className={classes.updateButton}
                onClick={editData}
                disabled={!username.trim()}
              >
                Save Profile
              </Button>
              </>
              
            </Box>
          </Modal>
        </div>

        <div>
          <Button onClick={handleOpenModalDelete} className={classes.DeleteButtonPopover}>
            <DeleteIcon /> Remove User
          </Button>
          <Modal
            keepMounted
            open={openModalDelete}
            onClose={handleCloseModalResetDelete}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
          >
            <Box className={classes.modal}>
              <CloseIconModals setSnackClose={handleCloseModalResetDelete} />
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
                className={classes.modalTitle}
              >
                Are you sure you want to delete this user?
                <i>{row.Email}</i>
              </Typography>

              <Button
                variant="contained"
                className={classes.updateButton}
                onClick={() => deleteRow()}
              >
                Delete User
              </Button>
              <Button variant="outlined" className={classes.cancelButton} onClick={handleCloseModalResetDelete}>
                Cancel
              </Button>
            </Box>
          </Modal>
        </div>

        <div>
          <Button onClick={handleToggleAdmin} className={classes.DeleteButtonPopover}>
            <AdminPanelSettingsIcon sx={{ marginRight: '8px' }} />
            {row.IsAdmin === 1 ? 'Revoke Admin Role' : 'Make Admin'}
          </Button>
        </div>
      </Popover>
    </div>
  );
}

